import { connect } from 'react-redux'
import StoriesWrapper from 'pages/dashboard/StoriesWrapper'

const mapStateToProps = (state, ownProps) => ({
  homepageArticles: state.ca.homepageArticles,
  aol: ownProps.aol
})

export default connect(mapStateToProps, null)(StoriesWrapper)
